import { Box } from '@air/zephyr';
import Image from 'next/image';

export interface AgencyCardImageProps {
  url?: string;
}

export const AgencyCardImage = ({ url }: AgencyCardImageProps) => {
  if (!url) return null;

  return (
    <Box
      tx={{
        borderRadius: 8,
        mb: 12,
        overflow: 'hidden',
        pb: '80%',
        position: 'relative',

        img: {
          objectFit: 'contain',
        },
      }}
    >
      <Image layout="fill" src={url} />
    </Box>
  );
};
